import { render, staticRenderFns } from "./Conteudo.vue?vue&type=template&id=2b4b5c2a&"
import script from "./Conteudo.vue?vue&type=script&lang=js&"
export * from "./Conteudo.vue?vue&type=script&lang=js&"
import style0 from "./Conteudo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports